import { useEffect, useId, useRef, useState } from 'react'
import { businessCategories } from '../../../shared/freeWebsite'

export function BusinessCategoryPicker({ value, onChange, invalid }: { value: string; onChange: (value: string) => void; invalid: boolean }) {
  const listId = useId()
  const [query, setQuery] = useState('')
  const [open, setOpen] = useState(false)
  const [active, setActive] = useState(0)
  const list = useRef<HTMLUListElement>(null)
  const options = businessCategories.filter(category => category.toLowerCase().includes(query.toLowerCase()))
  useEffect(() => { list.current?.children[active]?.scrollIntoView({ block: 'nearest' }) }, [active, open])
  function choose(category: string) { onChange(category); setQuery(''); setOpen(false) }
  return <div className="website-category-picker">
    <input id="website-category" role="combobox" aria-autocomplete="list" aria-expanded={open} aria-controls={listId} aria-activedescendant={open && options[active] ? `${listId}-${active}` : undefined} aria-invalid={invalid} aria-describedby={invalid ? 'website-category-error' : undefined} autoComplete="off" required placeholder="Search or choose a category" value={open ? query : value}
      onFocus={() => { setOpen(true); setQuery(''); setActive(0) }}
      onChange={event => { setQuery(event.target.value); setOpen(true); setActive(0); onChange('') }}
      onBlur={() => setOpen(false)}
      onKeyDown={event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault(); setOpen(true)
          setActive(index => Math.max(0, Math.min(options.length - 1, index + (event.key === 'ArrowDown' ? 1 : -1))))
        } else if (event.key === 'Enter' && open) {
          event.preventDefault(); if (options[active]) choose(options[active])
        } else if (event.key === 'Escape') { event.preventDefault(); setOpen(false) }
        else if (open && (event.key === 'Home' || event.key === 'End')) { event.preventDefault(); setActive(event.key === 'Home' ? 0 : options.length - 1) }
      }} />
    {open && <ul ref={list} id={listId} role="listbox" aria-label="Business categories">
      {options.map((category, index) => <li id={`${listId}-${index}`} key={category} role="option" aria-selected={index === active} onMouseDown={event => event.preventDefault()} onClick={() => choose(category)}>{category}</li>)}
      {!options.length && <li role="presentation">No matching categories. Clear your search and choose Other.</li>}
    </ul>}
  </div>
}
